<mat-accordion>
  <mat-expansion-panel [(expanded)]="isExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>Budgeted Revenue</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="col-md-2">
      @if (!editMode && permissions._edit) {
        <button mat-raised-button class="edit-button" (click)="toggleEdit()">EDIT</button>
      }
      @if (editMode && permissions._edit) {
        <button mat-raised-button class="edit-button" (click)="toggleEdit()">Cancel</button>
      }
    </div>
    @if (!editMode) {
      <div class="mat-elevation-z4">
        @if (budgetDetails.length> 0) {
          <table mat-table class="stripped-table" [dataSource]="getDataSource()" matSort>
            <ng-container matColumnDef="syndications_budget_year">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
              <td mat-cell *matCellDef="let row">{{row.syndications_budget_year}}</td>
            </ng-container>
            <ng-container matColumnDef="budget_amt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Budget Amount</th>
              <td mat-cell *matCellDef="let row">{{row.budget_amt | currency: 'USD': 'symbol': '1.0-0'}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="revenueColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: revenueColumns"></tr>
          </table>
        }
      </div>
    }
    @if (editMode) {
      <div class="mat-elevation-z4">
        <form [formGroup]="budgetForm">
          <ng-container formArrayName="details">
            <table mat-table class="stripped-table" [dataSource]="dataSource">
              <ng-container matColumnDef="syndications_budget_year">
                <th mat-header-cell *matHeaderCellDef>Year</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field>
                    <mat-label>Year</mat-label>
                    <input matInput formControlName="syndications_budget_year" name="syndications_budget_year" type="number">
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="budget_amt">
                <th mat-header-cell *matHeaderCellDef>Budget Amount</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field>
                    <mat-label>Budget Amount</mat-label>
                    <mat-icon matPrefix style="color: darkgray">attach_money</mat-icon>
                    <input matInput formControlName="budget_amt" name="budget_amt" type="number">
                    <mat-hint>{{row.value.budget_amt | currency: 'USD' : 'symbol': '1.0-0'}}</mat-hint>
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  <button mat-mini-fab class="action-button" (click)="save(row)"><i class="material-icons" style="font-size: 16px">save</i></button>
                  <button mat-mini-fab class="action-button" (click)="deleteRow(row)"><i class="material-icons" style="font-size: 16px">delete</i></button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="editColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: editColumns"></tr>
            </table>
          </ng-container>
        </form>
        <div class="row">
          <div class="col-sm-1">
            <button mat-mini-fab (click)="addRow()" class="add-btn"><i class="material-icons" style="font-size: 16px">add</i></button>
          </div>
        </div>
      </div>
    }
  </mat-expansion-panel>
</mat-accordion>
